module.exports = __webpack_public_path__ + "static/coding-3249e05d512e910fe7b6adcc931f3692.png";